import * as React from "react";
import { Moment } from "moment";
import { Grid, Loader } from "semantic-ui-react";
import { createValidator } from "not-valid";
import * as moment from "moment";

import { Input } from "@neworbit/simpleui-input";

import { MedicalTypeId } from "@teamprevent/common/healthSurveillance";

import { getMedicalTypeName } from "@teamprevent/common/customMedicalTypes/model";

import { useCustomMedicalTypes } from "../../../customMedicalTypes/hooks/useCustomMedicalTypes";

import { MEDICAL_TYPE_ID } from "../models";

import { DraggableMedicalType } from "./DraggableMedicalType";

interface Props {
    caseId: string;
    recallYear: number;
    recallWeek: number;
    recallDate: Moment;
    medicalTypes: MedicalTypeId[];
    editable: boolean;
    onDateChanged: (date: Moment) => void;
    onMedicalDropped: (medicalTypeId: MedicalTypeId) => void;
    hideRecallYearsAndWeeks: boolean;
    inflight: boolean;
}

const onDragOver =(event: React.DragEvent<HTMLElement>) => event.preventDefault();
const today = moment().utc(true).startOf("day");

const RecallCaseDetails: React.FunctionComponent<Props> = (props) => {
    const { inflight, onMedicalDropped } = props;
    const { customMedicalTypes, isLoaded: areCustomMedicalTypesLoaded } = useCustomMedicalTypes();

    const onDrop = React.useCallback((event: React.DragEvent<HTMLElement>) => {
        const droppedMedicalTypeId = event.dataTransfer.getData(MEDICAL_TYPE_ID) as MedicalTypeId;

        if (!droppedMedicalTypeId || inflight) {
            return; // Something was dropped other than a medical
        }

        onMedicalDropped(droppedMedicalTypeId);
    }, [inflight, onMedicalDropped]);

    const notInPastValidator = createValidator((value: moment.Moment) =>
        value && value.utc(true).startOf("day").isSameOrAfter(today), "Must not be in the past");

    const recallDate = React.useMemo(() => {
        return (props.recallDate ? props.recallDate.format("Do MMM YYYY") : "");
    }, [props.recallDate]);

    if (areCustomMedicalTypesLoaded === false)
    {
        return <Loader active />;
    }

    return (
        <>
            <Grid.Row onDragOver={onDragOver} onDrop={onDrop}>
                <Grid.Column width="6"><strong>{props.caseId}</strong></Grid.Column>
                { props.hideRecallYearsAndWeeks
                    ? <Grid.Column width="3" />
                    : <Grid.Column width="3"><strong>Recall Year: { props.recallYear ?? "" }</strong></Grid.Column>
                }
                { props.hideRecallYearsAndWeeks
                    ? <Grid.Column width="3" />
                    : <Grid.Column width="3"><strong>Recall Week: { props.recallWeek ?? "" }</strong></Grid.Column>
                }
                {  props.editable && !props.inflight ?
                    <Grid.Column width="4">
                        <strong>Recall Date: <Input.Date
                            value={props.recallDate }
                            onChange={props.onDateChanged}
                            validation={[notInPastValidator]} />
                        </strong>
                    </Grid.Column>
                    :
                    <Grid.Column width="4">
                        <strong>Recall Date: {recallDate}</strong>
                    </Grid.Column>
                }
                <Grid.Column width="16">
                    { props.editable && !props.inflight ?
                        props.medicalTypes.map(m => (
                            <DraggableMedicalType
                                medicalTypeName={getMedicalTypeName(customMedicalTypes, m)}
                                medicalTypeId={m}
                                key={m} />)) :
                        props.medicalTypes.map(m => getMedicalTypeName(customMedicalTypes, m)).join(", ")}
                </Grid.Column>
            </Grid.Row>
        </>
    );
};

export { RecallCaseDetails };
